import type { Ref, RefCallback } from 'react';

/** Whether a ref is a callback ref. */
export function isRefCallback<T>(value: Ref<T> | undefined): value is RefCallback<T> {
    return typeof value === 'function';
}
